// 响应式storage
import Storage from "responsive-storage";

import { responsiveStorageNameSpace } from "@/utils/config";

export const injectResponsiveStorage = app => {
  const nameSpace = responsiveStorageNameSpace;
  const configObj = Object.assign({
    // 国际化 默认中文zh
    locale: Storage.getData("locale", nameSpace) ?? {
      locale: "zh"
    }
  });

  app.use(Storage, { nameSpace, memory: configObj });
};
